import { FC } from "react";
import { FieldSetBox } from "./styles";

export const FieldSet: FC = ({ children }) => {
  return <FieldSetBox>{children}</FieldSetBox>;
};
